import { UserRole } from '../../store/types/context';

export const path = "/settings";
export { default as Component } from './Settings';
export const roles = [UserRole.Admin];
